<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0"
        width="100%" height="900" scrolling="auto" target='_top'></iframe>



// WEBPACK FOOTER //
// ./src/app/admin/docs/docs.component.html